<!--
  Herkunfts-Chip einer aufgelösten Provisionszeile: „eigene Zeile“ oder „geerbt aus «Matrix»“.
  p-tag ist der Chip-Baustein, den dieses Modul auch sonst für Urteile benutzt
  (cp-config-check-panel, bd-run-history-tab). Farbe trennt nur eigen/geerbt — die Aussage steht
  im Text, nicht in der Farbe.
-->
<p-tag [value]="label"
       [icon]="icon"
       [severity]="inherited ? 'warn' : 'success'"
       [pTooltip]="tooltip"
       tooltipPosition="top"
       styleClass="cp-origin-tag white-space-nowrap">
</p-tag>
